export const ADD_PREPAID_CARD = 'addPrepaidCard';
export const GIFT_CARD_NUMBER_TRANSLATION_ID = 'giftCardNumber';
